import './CardHead.css';

export function CardHead({ title, subtitle, actions }) {
  return (
    <div className="ui-card-head-row">
      <div className="ui-card-head-titles">
        {title && <div className="ui-card-head-title">{title}</div>}
        {subtitle && <div className="ui-card-head-sub">{subtitle}</div>}
      </div>
      {actions && <div className="ui-card-head-actions">{actions}</div>}
    </div>
  );
}
